import ScalarSidebarFooter_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarFooter.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarSidebar/ScalarSidebarFooter.vue
var ScalarSidebarFooter_default = ScalarSidebarFooter_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarFooter_default as default };

//# sourceMappingURL=ScalarSidebarFooter.vue.js.map